export default () => {
  SetMarkerForDesktop ()
  const markers = document.querySelectorAll ( '.js-marker' )
  const close = document.querySelectorAll ( '.js-mobile-close-button' )
  ;[...markers].forEach ( elem => {
    const descriptionId = elem.dataset.id
    if ( window.innerWidth > 1024 ) {
      elem.addEventListener ( 'mouseover', () => {
        const description = document.getElementById ( descriptionId )
        description.classList.remove ( 'c-image-marker__marker-text--hide' )
        description.classList.add ( 'c-image-marker__marker-text--show' )
      })
      elem.addEventListener ( 'mouseout', () => {
        const description = document.getElementById ( descriptionId )
        description.classList.add ( 'c-image-marker__marker-text--hide' )
        description.classList.remove ( 'c-image-marker__marker-text--show' )
      })
    }
    else{
      elem.addEventListener ( 'click', () => {
        const description = document.getElementById ( descriptionId )
        if(description.classList.contains ( 'c-image-marker__marker-text--show' ) ) {
          description.classList.add ( 'c-image-marker__marker-text--hide' )
          description.classList.remove ( 'c-image-marker__marker-text--show' )
        }
        else{
          removeAllDescriptions ( )
          description.classList.add ( 'c-image-marker__marker-text--show' )
        }
      })     
    }
  });
  ;[...close].forEach(closebuttons => {
    if ( window.innerWidth < 1025 ) {
      closebuttons.addEventListener ( 'click', () => {
        removeAllDescriptions ( )
      }) 
    }
  });
}

export function removeAllDescriptions ( ) {
  const descriptions = document.querySelectorAll ( '.js-marker-description' ) 
  ;[...descriptions].forEach ( elem => {
    if ( elem.classList.contains ( 'c-image-marker__marker-text--show' ) ) {
      elem.classList.add ( 'c-image-marker__marker-text--hide' )
      elem.classList.remove ( 'c-image-marker__marker-text--show' )
    }
  });
}

export function SetMarkerForDesktop ( ) {
  if ( window.innerWidth > 1024 ) {
    const description = document.querySelectorAll ( '.js-marker-description' )
    ;[...description].forEach ( elem => {
      const top = elem.dataset.top;
      const left = elem.dataset.left;
      elem.style.top=top + '%'
      elem.style.left=left + '%'
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/modules/Marker.js